<template>
  <FormModal v-if="showPopup" :closePopup="closePopup" />

    <div>
        <Navbar :openPopup="openPopup" />
        <!-- <PageTitle pageTitle="About Us" /> -->
        <About class="mt-40"/>
        <!-- <AboutMeander /> -->
       
        <!-- <ChallengesAndTrack /> -->
         <SetsApart/>
          <LaunchMobile/>
          <DigitalPartner />
          
           <Funfacts />
          <ExpertInsight />
            <Partner  />
           <SoftwareIntegrations />
    
       
        <div class="pb-3">
    <OurTeam />
          
        </div>
        <!-- <CustomerReviews class="pt-0" /> -->
        <Stats />
        <FooterStyleFour />
    </div>
</template>

<script>

import Navbar from '../Layout/Navbar'
 
import Funfacts from '../AboutOne/Funfacts.vue'
import ChallengesAndTrack from '../AboutOne/ChallengesAndTrack'
import Stats from '../AboutOne/Stats'
import SoftwareIntegrations from '../AboutOne/SoftwareIntegrations'
import CustomerReviews from '../Common/CustomerReviews'
import Partner from '../Common/Partner'
 import FooterStyleFour from '../Layout/FooterStyleFour'
import About from './AboutMeander/About.vue'
import OurTeam from './AboutMeander/OurTeam.vue'
import FormModal from '../HomeThree/FormModal.vue'
import LaunchMobile from '../AboutOne/LaunchMobile.vue'
import DigitalPartner from '../AboutOne/DigitalPartner.vue'
import ExpertInsight from '../AboutOne/ExpertInsight.vue'
import SetsApart from '../AboutOne/SetsApart.vue'

export default {
    name: 'AboutPageMeander',
    components: {
    Navbar,
    Funfacts,
    ChallengesAndTrack,
    LaunchMobile,
    DigitalPartner,
    CustomerReviews,
    ExpertInsight,
    Stats,
    SoftwareIntegrations,
    OurTeam,
    SetsApart,
    CustomerReviews,
    Partner,
    FooterStyleFour,
    About,
    FormModal
},
data(){
    return{
        showPopup:false
    }
},
methods: {
    openPopup(){
     this.showPopup  = true
    },
    closePopup(){
     this.showPopup= false
    },
        async gettitle() {
            // Set comprehensive SEO meta tags
            document.title = "About Us - Meander Software | Leading Software Development Company";
            
            // Helper to set or update a meta tag
            function setMeta(name, content, attr = 'name') {
              let element = document.querySelector(`meta[${attr}="${name}"]`);
              if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attr, name);
                document.head.appendChild(element);
              }
              element.setAttribute('content', content || '');
            }

            // Set basic meta tags
            setMeta('title', 'About Us - Meander Software | Leading Software Development Company');
            setMeta('description', 'Learn about Meander Software, a leading software development company. Discover our mission, values, team, and commitment to delivering innovative software solutions for businesses worldwide.');
            setMeta('keywords', 'about meander software, software development company, custom software solutions, development team, company mission, software company about us');

            // Open Graph tags
            setMeta('og:title', 'About Us - Meander Software | Leading Software Development Company', 'property');
            setMeta('og:description', 'Learn about Meander Software, a leading software development company. Discover our mission, values, team, and commitment to delivering innovative software solutions.', 'property');
            setMeta('og:type', 'website', 'property');
            setMeta('og:url', window.location.href, 'property');
            setMeta('og:image', 'https://meander.software/og-default-image.jpg', 'property');
            setMeta('og:image:width', '1200', 'property');
            setMeta('og:image:height', '630', 'property');
            setMeta('og:image:alt', 'About Us - Meander Software | Leading Software Development Company', 'property');

            // Twitter Card tags
            setMeta('twitter:title', 'About Us - Meander Software | Leading Software Development Company', 'name');
            setMeta('twitter:description', 'Learn about Meander Software, a leading software development company. Discover our mission, values, team, and commitment to delivering innovative software solutions.', 'name');
            setMeta('twitter:image', 'https://meander.software/og-default-image.jpg', 'name');
            setMeta('twitter:image:alt', 'About Us - Meander Software | Leading Software Development Company', 'name');
            setMeta('twitter:card', 'summary_large_image', 'name');
            setMeta('twitter:site', '@meandersoftware', 'name');
            setMeta('twitter:creator', '@meandersoftware', 'name');

            // Update canonical URL
            let canonical = document.querySelector('link[rel="canonical"]');
            if (canonical) {
              canonical.setAttribute('href', window.location.href);
            } else {
              canonical = document.createElement('link');
              canonical.setAttribute('rel', 'canonical');
              canonical.setAttribute('href', window.location.href);
              document.head.appendChild(canonical);
            }
        }
    },
    mounted: function() {  
        this.gettitle();
    }
}
</script>